<!-- Authored.by.KWShin.2024.01.12. -->
<template>
  <v-card ref="content" class="card-wrap">
    <v-card-title v-if="options.header ? options.header.show : true">
      {{ this.$t(options.title) }} {{ options.subTitle }}
      <div class="btn-right">
        <v-btn-toggle dense group>
          <!--Zoom On/Off-->
          <zoom v-if="zoomUse" :id="options.id" :active="zoomActive" />
          <!-- user's selected task-type -->
          <!--task-type v-if="taskTypeUse" :options="options" /-->
          <gear-menu v-if="gearMenuUse" :options="options" />
          <!--chart 설정-->
          <settings v-if="settingsChartUse" :options="options" />
          <!--grid 설정-->
          <field-selector v-if="settingsGridUse" :code="gridCode" :selected="gridSelectedFields" :store-name="options.id" />
        </v-btn-toggle>
      </div>
    </v-card-title>
    <div class="box">
      <slot name="content" :props="{ motlet: motletState }" />
    </div>
    <slot name="menu" :props="{ motlet: motletState }" />
  </v-card>
</template>

<script>
// import { mapState } from 'vuex';
import { merge } from 'lodash';
import bus from '@/utils/bus';
import motletable from '@/mixins/motletable';
import settings from './settings';
// import taskType from './taskType';
import gearMenu from './gearMenu';
import FieldSelector from './settings/FieldSelector';
import Zoom from './settings/Zoom';

/*
  Commented.by.KWShin.2024.01.12.
  1. Motelet.vue는 created() 시에 register() 메소드를 이용하여
      부모로부터 받은 Props 'options'를 Vuex store에 저장한다.
  2. Store에 저장할 때 @/store/modules/common/motlet.js에 있는 mutation 'common/motlet/setMotlet'를 이용한다.
      motlet.js는 위에서 import한 @/mixins/motletable.js 모듈에서 import 한다.
  3. 변수 'motletState'는 motletable.js 모듈에 computed()로 선언되어 있으며,
      store에서 저장된 값을 꺼내 온 것이다.
 */
export default {
  mixins: [motletable],
  components: {
    settings,
    // taskType,
    gearMenu,
    FieldSelector,
    Zoom,
  },
  props: {
    dense: [Boolean],
    options: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // BEGIN::Removed.by.KWShin.2024.01.02.
    // ...mapState('common/user', ['username']),
    // ...mapState('common/properties', ['partialTaskType']),
    // BEGIN::Removed.by.KWShin.2024.01.02.
    zoomUse() {
      return this.motletState.zoom?.use;
    },
    // taskTypeUse() {
    //   return this.motletState.taskType?.use;
    // },
    gearMenuUse() {
      return this.motletState.gearMenu?.use;
    },
    settingsChartUse() {
      return this.motletState.settings?.chart?.use;
    },
    settingsGridUse() {
      return this.motletState.settings?.grid?.use;
    },
  },
  watch: {
    // BEGIN::Added.by.KWShin.2024.08.31.
    // 오.. 이런. 모틀릿은 options.descendant 값의 변화가 반영이 안되게 되어 있네?
    // 반영해주자...
    'options.descendant': {
      deep: true,
      handler() {
        this.$store.dispatch('common/motlet/setDescendants', { id: this.motletId, descendants: this.getDescendants() });
        this.$store.dispatch('common/motlet/setDescendant', { id: this.motletId, descendant: this.getDescendant() });
      },
    },
    // FINISH::Added.by.KWShin.2024.08.31.
    /*
     * Commented.by.KWShin.2024.03.06.
     * 부모로부터 Props로 받은 값을 watch하다가
     * - 그 값을 matletable.js에 정의된 setTaskType()을 호출하는데,
     *   setTaskType()은 this.$store.dispatch('common/motlet/setTaskType', { id: this.motletId, taskType })를 호출한다.
     *   이 때, this.motletId는 부모에게서 받은 options(즉, 부모의 motletOptions)에 들어 있는 id이다.
     * - store의 action 'common/motlet/setTaskType'은 파라미터의 인자값을 이용하여
     *   state.motlet[param.id].taskType.selected 에 param.taskType 값을 할당한다.
     * - 즉, 모틀릿 ID 별로 특정 설정값이 store에 매달리게 된다.
     */
    'options.taskType.selected': {
      handler(value) {
        this.setTaskType(value);
      },
    },
    // BEGIN::Added.by.KWShin.2024.01.12.
    'options.loadKind.selected': {
      handler(value) {
        this.setLoadKind(value);
      },
    },
    // FINISH::Added.by.KWShin.2024.01.12.
    // BEGIN::Added.by.KWShin.2024.01.14.
    'options.logonType.selected': {
      handler(value) {
        this.setLogonType(value);
      },
    },
    // FINISH::Added.by.KWShin.2024.01.14.
    // BEGIN::Added.by.KWShin.2024.01.26.
    'options.yAxisMax.value': {
      handler(value) {
        this.setYAxisMax(value);
      },
    },
    // FINISH::Added.by.KWShin.2024.01.26.
    // BEGIN::Added.by.KWShin.2024.01.30.
    'options.abapDumpTerm.value': {
      handler(value) {
        this.setAbapDumpTerm(value);
      },
    },
    'options.updRecTerm.value': {
      handler(value) {
        this.setUpdRecTerm(value);
      },
    },
    // FINISH::Added.by.KWShin.2024.01.30.
    // BEGIN::Added.by.KWShin.2024.04.06.
    'options.xAxisPoints.value': {
      handler(value) {
        this.setXAxisPoints(value);
      },
    },
    // FINISH::Added.by.KWShin.2024.04.06.
  },
  methods: {
    register() {
      this.$store.dispatch('common/motlet/setMotlet', this.options);
      this.$store.dispatch('common/motlet/setDescendants', { id: this.motletId, descendants: this.getDescendants() });
      this.$store.dispatch('common/motlet/setDescendant', { id: this.motletId, descendant: this.getDescendant() });
      const monitor = merge({}, this.getMonitor(), this.options.monitor);
      this.$store.dispatch('common/motlet/setMonitor', { id: this.motletId, monitor });

      // response 내에서 지표로 사용할 field 값을 도출한다.
      // 기준 1: 임의로 지정된 field name 을 사용
      // 기준 2: motletCode 에 해당하는 filed 중에서 첫번째를 사용
      const chartValueField = this.monitor.valueField ? this.monitor.valueField : this.chartFields.length ? this.chartFields[0].code : '';
      this.setChartField(chartValueField);
      this.setGridSelectedFields(this.gridFields.filter(f => f.display).map(v => v.value));
      bus.$on(`change:selected-fields-${this.motletId}`, param => {
        this.setGridSelectedFields(param.fields);
      });
    },
    setZoomActive(active) {
      this.$store.dispatch('common/motlet/setZoomActive', { id: this.options.id, active });
    },
    getDescendants() {
      const systemId = this.options.descendant?.systemId;
      return this.$store.getters['common/system/getDescendantsById'](systemId);
    },
    getDescendant() {
      const id = this.options.descendant?.id;
      return (this.descendants || []).find(descendant => descendant.id == id);
    },
    getMonitor() {
      const systemId = this.options.monitor?.systemId;
      const monitorCode = this.options.monitor?.monitorCode;
      return this.$store.getters['common/monitor/getMonitor'](systemId, monitorCode);
    },
    setDense() {
      const target = this.$refs.content.$el.querySelector('div.box div.card-wrap div');
      target?.setAttribute('style', 'padding: 0px !important; margin: 0px !important;');
    },
  },
  mounted() {
    if (this.dense) this.setDense();
  },
  created() {
    this.register();
  },
  destroyed() {
    this.$store.dispatch('common/motlet/resetMotlet', this.options);
    bus.$off(`change:selected-fields-${this.motletId}`);
  },
};
</script>

<style scoped>
.v-application .pa-1 {
  padding: 0px !important;
}
.v-application .my-2 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>
